export default "__VITE_ASSET__3604dc8f__"